import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Divider, Link, Typography, Grid } from '@material-ui/core';
import {
  LoginJWT
} from '../../components/authentication/login';
import Logo from '../Shared/Logo';
import gtm from '../../lib/gtm';

const Login = () => {
  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Giriş | Joobid</title>
      </Helmet>
      <Box
        className="tp-auth__page"
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}
      >
        <Container
          maxWidth="lg"
          sx={{ py: '80px' }}
        >
          <Grid
            container
            spacing={3}
            sx={{ justifyContent: 'space-between' }}
          >
            <Grid
              item
              xs={12}
              md={7}
              className="jb-img-wrapper"
            >
              <img
                alt=""
                src="/static/assets/img/auth-login.svg"
                width={100}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 2
                }}
              >
                <RouterLink to="/">
                  <Logo
                    sx={{
                      height: 40,
                      width: 40
                    }}
                  />
                </RouterLink>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: 2
                }}
              >
                <div>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                    align="center"
                  >
                    Joobid&apos;e Hoşgeldiniz
                  </Typography>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h6"
                    align="center"
                  >
                    Lütfen hesabınıza giriş yapın...
                  </Typography>
                </div>
              </Box>
              <Card>
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    p: 4
                  }}
                >
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 0,
                      mt: 2
                    }}
                  >
                    <div>
                      <Typography
                        color="textPrimary"
                        gutterBottom
                        variant="h4"
                        className="jb-auth-title"
                      >
                        Kullanıcı Girişi
                      </Typography>
                    </div>
                  </Box>
                  <Box
                    sx={{
                      flexGrow: 1,
                      mt: 3
                    }}
                  >
                    <LoginJWT />
                  </Box>
                  <Divider sx={{ my: 3 }} />
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    to="/register"
                    variant="body2"
                  >
                    Yeni Hesap Oluştur
                  </Link>
                  <Link
                    color="textSecondary"
                    component={RouterLink}
                    sx={{ mt: 1 }}
                    to="/password-recovery"
                    variant="body2"
                  >
                    Şifremi Unuttum
                  </Link>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Login;
